import { useRef, useEffect } from 'react';
import { SketchPicker } from 'react-color';
import { Box, Typography} from '@mui/material';

export const Colors = ({ showPicker, templateForm, handleChange }) => {
    const colorRef = useRef(null);

    const closeOptions = () => {
        showPicker.set((p) => ({
            ...p,
            buttons: {
                ...p.buttons,
                palletPicker: false,
            }
        }))
    }

    useEffect(() => {
        const handleClickOutsidePallete = (event) => {
            if (colorRef.current && !colorRef.current.contains(event.target)) {
                closeOptions();
            }
        };

        if (showPicker.data.buttons.bg) {
            document.addEventListener("mousedown", handleClickOutsidePallete);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutsidePallete);
        };
        // eslint-disable-next-line
    }, [showPicker.data.buttons.bg]);
    
    const colorPicker = () => {
        showPicker.set(p => ({...p,buttons: { ...p.buttons, palletPicker: true, } }));
    }

    return (
        <Box p={2} display="flex" flexDirection="column" alignItems="center">
            <Typography fontWeight="600">Primary Color</Typography>
            <Box display="flex" flexDirection="column" alignItems="center">
                <Box bgcolor={templateForm.data.site_btns.bg} p={1} mt={1} height="32px" width="63px" borderRadius="8px" fontSize={12} onClick={() => colorPicker()}></Box>
                <Typography variant="overline">{templateForm.data.site_btns.bg}</Typography>
                {showPicker.data.buttons.palletPicker && (
                    <Box width="100%" mt={2} ref={colorRef}>
                        <SketchPicker
                            color={templateForm.data.site_btns.bg}
                            onChangeComplete={(color) =>
                                handleChange({
                                    target: { name: 'site_btns.bg', value: color.hex },
                                })
                            }
                        />
                    </Box>
                )}
            </Box>
        </Box>
    );
};